// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__26QCq","footer":"ChangeClinic_footer__2dIBj"};